module.exports = __webpack_public_path__ + "img/Dusshera 2.da36ce39.jpeg";